export default "__VITE_ASSET__Bww5QBgI__"